export interface EmailSupportRequest {
    subject: string;
    description: string;
}

export const getSupportTicketMessage = (request: EmailSupportRequest, userID?: number): string =>
    `${request.subject}\n\n${request.description}${userID && userID > 0 ? `\n\nUser ID: ${userID}` : ''}`;
